// Primary 4 English Learning Data
// Combined from p4Data-part1.js and p4Data-part2.js
// Based on Primary English Learning P4 Topics.txt

import { p4DataPart1 } from './p4Data-part1';
import { p4DataPart2 } from './p4Data-part2';

export const p4Data = {
  gradeId: p4DataPart1.gradeId,
  gradeName: p4DataPart1.gradeName,
  objectives: p4DataPart1.objectives,
  keySkills: p4DataPart1.keySkills,
  topics: [
    ...p4DataPart1.topics,
    ...p4DataPart2.topics
  ]
}; 